/** 与 hydrate-user-profile 共享的模块级状态，供 logout 时重置且避免与 store 循环依赖 */

let inflight: Promise<boolean> | null = null;
let profileHydratedOk = false;

export function resetUserProfileHydration(): void {
    inflight = null;
    profileHydratedOk = false;
}

export function getProfileHydratedOk(): boolean {
    return profileHydratedOk;
}

export function setProfileHydratedOk(ok: boolean): void {
    profileHydratedOk = ok;
}

export function getProfileHydrationInflight(): Promise<boolean> | null {
    return inflight;
}

export function setProfileHydrationInflight(promise: Promise<boolean> | null): void {
    inflight = promise;
}
